import {Component} from '@angular/core';

@Component({
    selector: 'app-walkthrough-introduction',
    templateUrl: './walkthrough-introduction.component.html',
    styleUrls: ['../product-walkthrough.component.scss'],
    standalone: false
})
export class WalkthroughIntroductionComponent
{
}
